import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { Skeleton } from "../Skeleton";
import { PracticeTestListItemSkeleton } from "./PracticeTestListItemSkeleton";

const SECTION_SEPARATOR_HEIGHT = 8;
const SUBHEADER_LINE_HEIGHT = 20;
const SUBHEADER_PADDING_VERTICAL = 18;
const TITLE_WIDTHS = ["70%", "55%", "62%"] as const;

export type PracticeTestsSkeletonSection = {
	numRows: number;
	showRightChip?: boolean;
};

type Props = {
	sections?: PracticeTestsSkeletonSection[];
};

const DEFAULT_SECTIONS: PracticeTestsSkeletonSection[] = [
	{ numRows: 2, showRightChip: true },
	{ numRows: 2, showRightChip: false },
];

const SectionHeaderSkeleton = ({
	showRightChip,
}: { showRightChip?: boolean }) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box
			gap={16}
			backgroundColor={theme.colors.background}
			paddingHorizontal={isMobile ? 16 : 0}
		>
			<Box
				justifyContent="space-between"
				flexDirection="row"
				alignItems="center"
			>
				<Box
					paddingVertical={SUBHEADER_PADDING_VERTICAL}
					height={SUBHEADER_LINE_HEIGHT + SUBHEADER_PADDING_VERTICAL * 2}
					justifyContent="center"
				>
					<Skeleton width={164} height={14} />
				</Box>
				{showRightChip && <Skeleton width={70} height={30} />}
			</Box>
		</Box>
	);
};

export const PracticeTestsSkeleton = ({
	sections = DEFAULT_SECTIONS,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box>
			{sections.map(({ numRows, showRightChip }, sectionIndex) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton sections
				<Box key={sectionIndex}>
					<SectionHeaderSkeleton showRightChip={showRightChip} />
					<Box height={SECTION_SEPARATOR_HEIGHT} />
					<Box gap={isMobile ? 0 : 16}>
						{Array.from({ length: numRows }).map((_, rowIndex) => (
							<PracticeTestListItemSkeleton
								// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton rows
								key={rowIndex}
								titleWidth={TITLE_WIDTHS[rowIndex % TITLE_WIDTHS.length]}
							/>
						))}
					</Box>
					<Box height={SECTION_SEPARATOR_HEIGHT} />
				</Box>
			))}
		</Box>
	);
};
